import React, { Fragment, useEffect, useState } from "react";
import { Grid, Table, Pagination, Segment, Icon ,Menu } from "semantic-ui-react";
import { Link, withRouter } from "react-router-dom";
import { Button, Dropdown, Form, Image } from "semantic-ui-react";

import { Helmet } from "react-helmet";
import e from "cors";
import ".//vmcohorts.css";
import { upperFirst } from "lodash";
const options = [
  { key: 1, text: 'ID', value: 'ID' },
  { key: 2, text: 'NAME', value: 'NAME'},
  
]
const VMCohortListing = ({
  loading,
  vmCohortList,
  totalPages,
  activePage,
  onPageChange,
  OnClickVMSideDetailsPage,
  vmCohortDetails,
  cohorts_types,
  onChangeOfVMTypeId,
  UpadateBaseDetails,
  onChangeOfVMCohort,
  onChangeOfAddUsersCohort,
  cohortvalue,
  cohortvalue1,
  addvm,
  users,
  AddVMfun,
  AddUsersfun,
  removeVmCohorts,
  removeUsersCohorts,
  getCohortsDetailsAPI,
  // onClickOfDeleteUser,
  onChangeOfName,
  onChangeOfAreaName,
  onChangeOfCohortsTypeId,
  onChangeOfdescription,
  area_name,
  history,
  onClickOfDelete,
  cohort_name,
  onChangeOfLat,
  onChangeOfLng,
  description,
  AddusersList,
  handleCreateCohorts,

  lng,
  lat,
  limit,
  totalCount,
  openbasicvmmodal,
  openbasicvmmodalFun,
  closebasicvmmodelFun,
  closeaddvmmodelFun,
  openaddvmmodalFun,
  openaddvmmodal,
  modal,
  openmodel,
  closemodel,
  openremoveVmmodalFun,
  closeremoveVmmodalFun,
  removevmmodal,
  openaddUsersmodal,
  openAddusersmodalFun,
  closeAddusersmodalFun,
  removeusersmodal,
  openremoveusersmodalFun,
  closeremoveusersmodalFun,
  onChangeSelectFilterType,
  onSearchInputChange,
}) => {
  console.log("MODEL -------------", modal);
  console.log("OPEN MODEL -----Add--------", openaddvmmodal);

  const [view1, setView1] = useState(true);

  const [view2, setView2] = useState(false);
  const [view3, setView3] = useState(false);
  const [view4, setView4] = useState(false);
  const [width, setWidth] = useState("50%");
  /*   const [modal,setModal]=useState(false) */
  const [upmodal, setupModal] = useState(false);
  const [upmodal1, setupModal1] = useState(false);
  const [vmid, setVmid] = useState("");
  const [searchQuery, setsearchQuery] = useState([]);
  const [searchQuery1, setsearchQuery1] = useState([]);
  const [cohortName, setCohortname] = useState("");
  const [cohortArea, setCohortarea] = useState("");
  const [cohortDesc, setCohortadesc] = useState("");
  const [vmCohortDetails1, setvmCohortDetails1] = useState([]);
  const [addvmmodal, setAddvmmodal] = useState(false);

  /*   const [openaddvmmodal,setOpenaddvmmodal]=useState(false);
   */

  /* const [openaddUsersmodal,setOpenaddUsersmodal]=useState(false); */
  /*  const [openbasicvmmodal,setBasicaddvmmodal]=useState(false); */

  /*  const [removevmmodal,setRemovevmmodal]=useState(false); */
  /*   const [removeusersmodal,setRemoveusersmodal]=useState(false); */

  const handleSearchChange = (e, { searchQuery }) => {
    setsearchQuery(searchQuery);
    console.log("search", searchQuery);
  };
  const handleSearchAddUserCohort = (e, { searchQuery1 }) => {
    setsearchQuery1(searchQuery1);
    console.log("search", searchQuery1);
  };
  console.log("cohorts_types COMPONENT PAGE", cohorts_types);


  const openupdatemodal1 = () => {
    console.log("Model Open");
    setupModal1(!upmodal1);
    setModal(false);
    setupModal(false);
  };
  const closeupdatemodal = () => {
    console.log("Model Open");
    setupModal(!upmodal);
    setModal(true);
  };
  const closeupdatemodal1 = () => {
    console.log("Model Open");
    setupModal1(!upmodal);
    setModal(true);
  };

  const handleView2 = () => {
    setView2(!view2);
  };

  const vmDetails = (id) => {
    setWidth("35%");
    setVmid(id);
    OnClickVMSideDetailsPage(id);
  };
  const handleView4 = () => {
    setView4(!view4);
  };

  const handleView3 = () => {
    setView3(!view3);
  };
  const handleView1 = () => {
    setView1(!view1);
  };
  const UpadateBasicDetails = () => {
    console.log("CLICKED");
    UpadateBaseDetails(vmid);
    /* setModal(false); */

    /*  closeaddvmmodelFun(); */
  };

  const AddVMInCohortFun = () => {
    console.log("CLICKED", vmid);
    AddVMfun(vmid);
  };

  const UpadateBasicDetails2 = () => {
    console.log("CLICKED");
    AddUsersfun(vmid);
  };
  const removeVmFun = (e, id) => {
    e.preventdefault;
    console.log("COHOTS ID ____________________", vmid);

    console.log("removeVM-------------------------", id);
    onClickOfDelete(id, vmid);
  };

  const removeuserFun = (e, id) => {
    e.preventdefault;
    console.log("COHOTS ID ____________________", vmid);

    console.log("removeVM-------------------------", id);
    removeUsersCohorts(id, vmid);
  };

  const removeUsersFun = (e, id) => {
    e.preventdefault;
    console.log("COHOTS ID ____________________", vmid);
    setVmid(id);
    console.log("removeVM-------------------------", id);
    onClickOfDelete(id, vmid);
  };
  const handleChangeName = (e) => {
    console.log(e.target.value);
    setCohortname(e.target.value);
  };
  const handleChangeArea = (e) => {
    console.log(e.target.value);
    setCohortarea(e.target.value);
  };

  const handleChangeDesc = (e) => {
    console.log(e.target.value);
    setCohortadesc(e.target.value);
  };

  console.log("vmCohortLIST--->", vmCohortList);

  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: "90vh" }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        
       "marginLeft":"15%",
        "margin-top": "3%",
      }}
    >
      {openaddUsersmodal && (

<div className="modal1">
<div className="modal-content1">
  <p style={{ cursor: "pointer" }} onClick={closeAddusersmodalFun}>
    Close
  </p>

  <div style={{ "margin-left": "22%", marginRight: "22%" }}>
    {/* <p style={{ "font-size": "20px" }}>Cohorts Id:-{vmid}</p>
 */}
    <div style={{ display: "grid" }}>
      <label style={{ "margin-bottom": "1%" }}>ADD USERS</label>
      <Form.Dropdown
        search
        fluid
        multiple
        onChange={onChangeOfAddUsersCohort}
        onSearchChange={handleSearchAddUserCohort}
        options={AddusersList}
        placeholder="ADD USERS"
        
        searchQuery={searchQuery1}
        selection
        value={cohortvalue1}
        style={{
          "border-color": "white",
          "font-size": "20px",
          "background-color": "#f7f7f7",
        }}
      />
      <button
        style={{
          padding: "16px",
          "margin-top": "5%",
          color: "white",
          "background-color": "green",
          color: "white",
          border: "none",
          "border-radius": "10px",
        }}
        onClick={UpadateBasicDetails2}
      >
        ADD USER
      </button>
    </div>
  </div>
</div>
</div>


          
   
      )}

      {removeusersmodal && (
        <div className="modal1">
          <div style={{ overflow: "auto" }} className="modal-content1">
            <p style={{ cursor: "pointer" }} onClick={closeremoveusersmodalFun}>
              Close
            </p>

            <Fragment>
              <table style={{ width: "100%" }}>
                <tr>
                  <th>ID</th>
                  <th>NAME</th>
                  <th>PHONE</th>
                  <th>DELETE</th>
                </tr>

                {vmCohortDetails.users.length ? (
                  vmCohortDetails.users.map((el) => (
                    <Fragment>
                      {el.id > 0 && (
                        <Fragment>
                          <tr
                            style={{ cursor: "pointer" }}
                            key={el.id}
                            value={el.id}
                          >
                            <td>{el.id}</td>

                            <td>{el.name}</td>

                            <td>{el.phone}</td>
                            <td>
                              <button
                                onClick={(e) => {
                                  removeuserFun(e, el.id);
                                }}
                              >
                                DELETE
                              </button>
                            </td>
                          </tr>
                        </Fragment>
                      )}
                    </Fragment>
                  ))
                ) : (
                  <Fragment>
                    {" "}
                    <tr>
                      <td> </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </Fragment>
                )}
              </table>
            </Fragment>

            <div style={{ "margin-left": "22%", marginRight: "22%" }}>
              {/* <p style={{ "font-size": "20px" }}>Cohorts Id:-{vmid}</p> */}
            </div>
          </div>
        </div>
      )}

      {removevmmodal && (
        <div className="modal1">
          <div style={{ overflow: "auto" }} className="modal-content1">
            <p style={{ cursor: "pointer" }} onClick={closeremoveVmmodalFun}>
              Close
            </p>

            <Fragment>
              <table style={{ width: "100%" }}>
                <tr>
                  <th>VM-ID</th>
                  <th>NAME</th>
                  <th>ACTION</th>
                </tr>

                {vmCohortDetails.machines &&
                  vmCohortDetails.machines.length &&
                  vmCohortDetails.machines.map((el) => (
                    <Fragment>
                      {el.id > 0 && (
                        <Fragment>
                          <tr key={el.id} value={el.id}>
                            <td>{el.id}</td>

                            <td>{el.name}</td>
                            <td>
                              <button
                                onClick={(e) => {
                                  removeVmFun(e, el.id);
                                }}
                                key={el.id}
                                value={el.id}
                              >
                                DELETE
                              </button>
                            </td>
                          </tr>
                        </Fragment>
                      )}
                    </Fragment>
                  ))}
              </table>
              <hr />
            </Fragment>

           {/*  <div style={{ "margin-left": "22%", marginRight: "22%" }}>
              <p style={{ "font-size": "20px" }}>Cohorts Id:-{vmid}</p>
            </div> */}
          </div>
        </div>
      )}

      {openaddvmmodal && (
        <div className="modal1">
          <div className="modal-content1">
            <p style={{ cursor: "pointer" }} onClick={closeaddvmmodelFun}>
              Close
            </p>

            <div style={{ "margin-left": "22%", marginRight: "22%" }}>
              {/* <p style={{ "font-size": "20px" }}>Cohorts Id:-{vmid}</p>
 */}
              <div style={{ display: "grid" }}>
                <label style={{ "margin-bottom": "1%" }}>ADD MACHINE</label>
                <Form.Dropdown
                  fluid
                  multiple
                  onChange={onChangeOfVMCohort}
                  onSearchChange={handleSearchChange}
                  options={addvm}
                  placeholder="State"
                  search
                  searchQuery={searchQuery}
                  selection
                  value={cohortvalue}
                  style={{
                    "border-color": "white",
                    "font-size": "20px",
                    "background-color": "#f7f7f7",
                  }}
                />
                <button
                  style={{
                    padding: "16px",
                    "margin-top": "5%",
                    color: "white",
                    "background-color": "green",
                    color: "white",
                    border: "none",
                    "border-radius": "10px",
                  }}
                  onClick={AddVMInCohortFun}
                >
                  ADD
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {openbasicvmmodal && (
        <div className="modal1">
          <div className="modal-content1">
            <p style={{ cursor: "pointer" }} onClick={closebasicvmmodelFun}>
              Close
            </p>

            <div style={{ "margin-left": "20%", "margin-right": "20%" }}>
               {/* <p style={{ "font-size": "20px" }}>Cohorts Id:-{vmid}</p>  */}

              <Grid.Row style={{ marginBottom: "8em" }}>
                <Grid.Column width={8}>
                  <Form>
                    <Form.Field required style={{ "margin-bottom": "3rem" }}>
                      <label>COHORT NAME</label>
                      <input
                        placeholder="Enter Cohorts Name "
                        value={cohort_name}
                        onChange={onChangeOfName}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field required style={{ "margin-bottom": "3rem" }}>
                      <label>COHORT TYPE</label>
                      <Dropdown
                        placeholder="Select Cohort Type"
                        // loading={loading}
                        selection
                        search
                        options={cohorts_types}
                        onChange={onChangeOfCohortsTypeId}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field required style={{ "margin-bottom": "3rem" }}>
                      <label>DESCRIPTION</label>
                      <input
                        placeholder="Enter Description "
                        value={description}
                        onChange={onChangeOfdescription}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field required style={{ "margin-bottom": "3rem" }}>
                      <label>AREA NAME</label>
                      <input
                        placeholder="Enter Area Name "
                        value={area_name}
                        onChange={onChangeOfAreaName}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <div style={{ display: "flex", marginBottom: "2rem" }}>
                      <Form.Field required style={{ width: "52%" }}>
                        <input
                          placeholder="Latitude"
                          value={lat}
                          onChange={onChangeOfLat}
                          style={{
                            "border-color": "white",
                            "font-size": "20px",
                            "background-color": "#f7f7f7",
                          }}
                        />
                      </Form.Field>

                      <Form.Field
                        required
                        style={{ width: "54%", "margin-left": "2px" }}
                      >
                        <input
                          placeholder="Longitude"
                          value={lng}
                          onChange={onChangeOfLng}
                          style={{
                            "border-color": "white",
                            "font-size": "20px",
                            "background-color": "#f7f7f7",
                          }}
                        />
                      </Form.Field>
                    </div>
                  </Form>
                  <Button
                    color="blue"
                    onClick={UpadateBasicDetails}
                    /*  onClick={e=>{onChangeOfCohortsTypeId(e,inputFields)}} */ style={{
                      width: "100%",
                      padding: "20px",
                      "font-size": "20px",
                    }}
                  >
                    UPDATE
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </div>
          </div>
        </div>
      )}

      {modal && (
        <div className="modal">
          <div className="modal-content">
            <p style={{ cursor: "pointer" }} onClick={closemodel}>
              Close
            </p>
            <div
              style={{
                display: "grid",
                width: "50%",
                marginLeft: "25%",
                "margin-left": "25%",
                "margin-top": "10%",
              }}
            >
              <button
                onClick={openbasicvmmodalFun}
                style={{
                  "margin-bottom": "2%",
                  padding: "3%",
                  color: "white",
                  backgroundColor: "green",
                  border: "none",
                  "border-radius": "10px",
                  "font-size": "25px",
                }}
              >
                UPDATE BASIC DETAILS
              </button>
              <button
                onClick={openaddvmmodalFun}
                style={{
                  "margin-bottom": "2%",
                  padding: "3%",
                  color: "white",
                  backgroundColor: "green",
                  border: "none",
                  "border-radius": "10px",
                  "font-size": "25px",
                }}
              >
                ADD VENDING MACHINE
              </button>
              <button
                onClick={openremoveVmmodalFun}
                style={{
                  "margin-bottom": "2%",
                  padding: "3%",
                  color: "white",
                  backgroundColor: "green",
                  border: "none",
                  "border-radius": "10px",
                  "font-size": "25px",
                }}
              >
                REMOVE VENDING MACHINE
              </button>
              <button
                onClick={openAddusersmodalFun}
                style={{
                  "margin-bottom": "2%",
                  padding: "3%",
                  color: "white",
                  backgroundColor: "green",
                  border: "none",
                  "border-radius": "10px",
                  "font-size": "25px",
                }}
              >
                ADD USERS
              </button>
              <button
                onClick={openremoveusersmodalFun}
                style={{
                  "margin-bottom": "2%",
                  padding: "3%",
                  color: "white",
                  backgroundColor: "green",
                  border: "none",
                  "border-radius": "10px",
                  "font-size": "25px",
                  
                }}
              >
                REMOVE USERS
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{width:"60%","box-shadow":" 0 2px 14px 1px #504c4c","margin-bottom":"14px"}}>
        <div>
          <table>
            <th>
            <div style={{display:"flex"}}>
              <Menu compact>
              <Dropdown placeholder="FILTER" options={options}  simple item  
                onChange={onChangeSelectFilterType}/>
              </Menu>
              <input
                placeholder="Search by Id or Name"
                style={{ padding: "10px", width: "100%" }}
                onChange={onSearchInputChange} 
              /> 
              </div>
            </th>
            <th>
              <button
                style={{
                  "font-size": "14px",
                  padding: "14px",
                  color: "white",
                  "background-color": "green",
                  border: "none",
                  "border-radius": "10px",
                  width: "100%",
                }}

                onClick={handleCreateCohorts}
              >
               
                CREATE COHORTS
              </button>
            </th>
          </table>
        </div>
       
        <div
          style={{
            display: "flex",
            width: "100%",
            
            "margin-top": "3%"
          }}
        >

          <div style={{width:"100%",height:"783px",overflow:"auto"}}>
            <table >
              <tr>
                <th>Cohorts Id</th>
                <th>Cohort Name</th>
                <th>Type</th>
              </tr>
              {vmCohortList &&
                vmCohortList.length &&
                vmCohortList.map((el) => (
                  <Fragment>
                    {el.id > 0 && (
                      <Fragment>
                        <tr
                          style={{ cursor: "pointer" }}
                          key={el.id}
                          value={el.id}
                          onClick={(e) => {
                            vmDetails(el.id);
                          }}
                        >
                          <td>{el.id}</td>

                          <td>{el.name}</td>

                          <td>{el.type}</td>
                        </tr>
                      </Fragment>
                    )}
                  </Fragment>
                )).reverse()}
            </table>
          </div>
        </div>
      </div>
      {vmCohortDetails && (
        <div
        style={{
          background: "fffff",
          width: "45%",
          "margin-left": "2%",
        
          height: "59.7rem;",
          border: "2px solid beige",
          "overflow-y": "scroll",
          "overflow-x": "hidden",
          height: "880px",
          "marginBottom":"14px",
          "box-shadow":" 0 2px 14px 1px #504c4c",
          "margin-right": "16%"

          /*  "box-shadow": "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
           */
        }}
        >
                    <div style={{display:"flex","justify-content": "space-between",    "align-items": "center",    padding: "10px"}}>
            
  
             <div style={{ display: "flex"}} >
                <div style={{display:"flex"}}>
              <div><h3 >STATUS:</h3></div>    
              <div>
              <h3 >
                
              {vmCohortDetails.cohortTypeName}
              </h3>
              </div>
              </div>
              </div>
              
           
            <div>
              <button
                 onClick={openmodel}
                style={{
                  padding: "6px 32px",
                  height: "40px",
                 
                  cursor: "pointer",
                  "background-color": "green",
                  color: "white",
                  "background-color": "green",
                  border: "white",
                  "border-radius": "10px",
                }}
              >
                EDIT
              </button>
              </div>
              
              
            
          </div>

          
          <hr />

          <div style={{ width: "100%", "margin-left": "0rem" }}>
            <div style={{ "margin-top": "0px", "margin-left": "5%" }}>
              <div style={{ display: "flex" }}>
                <h3 style={{ color: "brown", "font-size": "16px" }}>ID:-</h3>
                <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                  {vmCohortDetails.id}
                </h3>
              </div>
              <div style={{ display: "flex", width: "99%" }}>
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  COHORTS NAME:-
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {vmCohortDetails.name}
                </h3>
              </div>

              <div style={{ display: "flex", width: "99%" }}>
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  TOTAL MACHINE:-
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {vmCohortDetails.machines.length}
                </h3>
              </div>
              <div style={{ display: "flex", width: "99%" }}>
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  TOTAL USERS:-
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {vmCohortDetails.users.length}
                </h3>
              </div>
              <div style={{ display: "flex", width: "99%" }}>
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  AREA NAME:-
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {vmCohortDetails.areaName}
                </h3>
              </div>

              <div style={{ display: "flex", width: "99%" }}>
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  DESCRIPTION:-
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {vmCohortDetails.description}
                </h3>
              </div>
            </div>

            <div>
              <hr />

              <p
                style={{ display: "flex", "justify-content": " space-around" }}
              >
                MACHINE
                <p
                  onClick={handleView2}
                  style={{
                    "text-align": "center",
                    color: "blue",
                    cursor: "pointer",
                  }}
                >
                  {view2 ? (
                    <Fragment>HIDE</Fragment>
                  ) : (
                    <Fragment>VIEW</Fragment>
                  )}
                </p>
              </p>
            </div>
          </div>
          <hr />

          {view2 && (
            <Fragment>
              <table style={{ width: "90%" }}>
                <tr>
                  <th>VM-ID</th>
                  <th>NAME</th>
                </tr>

                {vmCohortDetails.machines &&
                  vmCohortDetails.machines.length &&
                  vmCohortDetails.machines.map((el) => (
                    <Fragment>
                      {el.id > 0 && (
                        <Fragment>
                          <tr
                            style={{ cursor: "pointer" }}
                            key={el.id}
                            value={el.id}
                          >
                            <td>{el.id}</td>

                            <td>{el.name}</td>
                          </tr>
                        </Fragment>
                      )}
                    </Fragment>
                  ))}
              </table>
              <hr />
            </Fragment>
          )}
          <div>
            <p style={{ display: "flex", "justify-content": " space-around" }}>
              LOG{" "}
              <p
                onClick={handleView3}
                style={{
                  "text-align": "center",
                  color: "blue",
                  cursor: "pointer",
                }}
              >
                {view3 ? <Fragment>HIDE</Fragment> : <Fragment>VIEW</Fragment>}
              </p>
            </p>
          </div>

          <hr />

          {view3 && (
            <Fragment>
              <table style={{ width: "90%" }}>
                <tr>
                  <th>Date</th>
                  <th>User-Id/Machine-Id</th>
                  <th>Change-Type</th>
                </tr>

                {vmCohortDetails.logs.length ? (
                  vmCohortDetails.logs.map((el) => (
                    <Fragment>
                      {vmCohortDetails.logs ? (
                        <tr
                          style={{ cursor: "pointer" }}
                          key={el.id}
                          value={el.id}
                        >
                          <td>{el.createdAt}</td>
                          {el.machineId ? (
                            <td>{el.machineId}</td>
                          ) : (
                            <td>{el.userId}</td>
                          )}

                          <td>{el.changeType}</td>
                        </tr>
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </Fragment>
                  ))
                ) : (
                  <Fragment>
                    {" "}
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>
                  </Fragment>
                )}
              </table>
              <hr />
            </Fragment>
          )}
          <div>
            <p style={{ display: "flex", "justify-content": " space-around" }}>
              USERS{" "}
              <p
                onClick={handleView4}
                style={{
                  "text-align": "center",
                  color: "blue",
                  cursor: "pointer",
                }}
              >
                {view4 ? <Fragment>HIDE</Fragment> : <Fragment>VIEW</Fragment>}
              </p>
            </p>
          </div>

          {view4 && (
            <Fragment>
              <table style={{ width: "90%" }}>
                <tr>
                  <th>ID</th>
                  <th>NAME</th>
                  <th>PHONE</th>
                </tr>

                {vmCohortDetails.users.length ? (
                  vmCohortDetails.users.map((el) => (
                    <Fragment>
                      {el.id > 0 && (
                        <Fragment>
                          <tr
                            style={{ cursor: "pointer" }}
                            key={el.id}
                            value={el.id}
                          >
                            <td>{el.id}</td>

                            <td>{el.name}</td>

                            <td>{el.phone}</td>
                          </tr>
                        </Fragment>
                      )}
                    </Fragment>
                  ))
                ) : (
                  <Fragment>
                    {" "}
                    <tr>
                      <td> </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </Fragment>
                )}
              </table>
            </Fragment>
          )}

          <hr />
        </div>
      )}
    </div>
  );
};

export default withRouter(VMCohortListing);



// WEBPACK FOOTER //
// ./src/Modules/VMCohortList/component.jsx